var _sodipodiNamedview, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    id: "svg7767",
    xmlSpace: "preserve",
    sodipodiDocname: "year.svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7771"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 44.5,
    stroke: "#42c0ef",
    strokeWidth: 3,
    id: "circle7765",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.045755,20.942646 v 5.455301 m 27.276488,-5.455298 v 5.455298 M 30.863635,70.040329 h 31.640728 c 3.055239,0 4.582995,0 5.749884,-0.594628 1.026414,-0.52289 1.861075,-1.35755 2.383966,-2.383965 0.594626,-1.166888 0.594626,-2.694644 0.594626,-5.749883 v -26.18543 c 0,-3.055267 0,-4.582886 -0.594626,-5.74983 -0.522891,-1.026495 -1.357552,-1.861048 -2.383966,-2.384047 -1.166889,-0.594599 -2.694645,-0.594599 -5.749884,-0.594599 H 30.863635 c -3.055239,0 -4.582886,0 -5.749829,0.594599 -1.026496,0.522999 -1.861047,1.357552 -2.384047,2.384047 -0.5946,1.166944 -0.5946,2.694563 -0.5946,5.74983 v 26.18543 c 0,3.055239 0,4.582995 0.5946,5.749883 0.523,1.026415 1.357551,1.861075 2.384047,2.383965 1.166943,0.594628 2.694562,0.594628 5.749829,0.594628 z",
    stroke: "#000000",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1",
    sodipodiNodetypes: "ccccccssccssccssccssc",
    style: {
      stroke: "#42c0ef",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#660080",
      stroke: "#42c0ef",
      strokeWidth: 1.938,
      strokeLinecap: "round",
      strokeDasharray: "none"
    },
    d: "m 33.015119,48.175375 27.31144,0.05431",
    id: "path2",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#660080",
      stroke: "#42c0ef",
      strokeWidth: 1.938,
      strokeLinecap: "round",
      strokeDasharray: "none"
    },
    d: "m 33.037058,59.116408 9.297766,0.01271",
    id: "path3",
    sodipodiNodetypes: "cc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#660080",
      stroke: "#42c0ef",
      strokeWidth: 1.938,
      strokeLinecap: "round",
      strokeDasharray: "none"
    },
    d: "m 22.875238,37.254871 46.758029,0.01647",
    id: "path4",
    sodipodiNodetypes: "cc"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default __webpack_public_path__ + "static/media/year.163c76b8c68c7fae2a402adb344a1324.svg";
export { ForwardRef as ReactComponent };